var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRecommendations = function SvgRecommendations(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m12.409 6.189 8.235 3.317L11.866 6c.03.004.16.032.533.185zM11.86 6l8.783 3.506-8.64 3.351-.842-.323c-.944-.362-2.215-.852-3.52-1.363A259 259 0 0 1 3.92 9.687l-.678-.28L11.2 6.2c.49-.179.634-.199.661-.2m.005 0h-.007m1.297-1.666c-1.088-.445-1.46-.445-2.673 0l-9.93 4c-.792.444-.791 1.54.382 2.222.365.212 1.577.723 3.072 1.326A1 1 0 0 0 4 12v5.6a1 1 0 0 0 .676.946l7 2.4a1 1 0 0 0 .649 0l7-2.4A1 1 0 0 0 20 17.6V12a1 1 0 0 0-.005-.097l3.473-1.347c.764-.445.764-1.778-.382-2.223zM18 12.677 12.01 15S8.93 13.829 6 12.675v4.21l6 2.058 6-2.057zM1.855 8.769",
    clipRule: "evenodd"
  })));
};
export default SvgRecommendations;